<template>
    <div class="assortment__body" v-if="category">
      <div class="assortment__filter-mobile filter-assortment-mobile">
        <div class="filter-assortment-mobile__col filter-assortment-mobile__col_left">
          <div class="h2 filter-assortment-mobile__title" v-if="category.meta">{{ category.meta.title }}</div>
        </div>
        <div class="filter-assortment-mobile__col filter-assortment-mobile__col_right">
          <div class="filter-assortment-mobile__actions actions-filter-mobile">
            <button type="button" class="actions-filter-mobile__button actions-filter-mobile__button_view" data-view-mode @click="changeFlowerCardMode">
              <svg class="icon" id="grid-mode" v-bind:class="{ '_active': flowerCardMode == 'card-mode' }">
                <use xlink:href="/img/front/icons/svgmap.svg#grid-mode"></use>
              </svg>
              <svg class="icon" id="card-mode" v-show="flowerCardMode == 'grid-mode'" v-bind:class="{ '_active': flowerCardMode == 'grid-mode' }">
                <use xlink:href="/img/front/icons/svgmap.svg#card-mode"></use>
              </svg>
            </button>
            <button type="button" class="actions-filter-mobile__button actions-filter-mobile__button_filter btn btn-filter filter-open" id="btn-filter">
              <svg class="icon">
                <use xlink:href="/img/front/icons/svgmap.svg#filter" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- Filter vue js template -->
      <filter_flow :categories="child_categories" :title="category.meta.title" :max_price="max_price" :min_price="min_price" @change="filter"></filter_flow>

      <div class="assortment__content" :class="{ 'disable-block': loading, '_card-view': flowerCardMode == 'card-mode'}">
        <div class="assortment__grid grid-assortment">
            <product_item_flow v-for="(product, index) in products_pagged.data" :key="index" :product="product"></product_item_flow>
        </div>

        <button v-if="!lastPage" class="assortment__load-more btn btn-load" type="button" @click="getMoreResults">
          <svg class="icon">
            <use xlink:href="/img/front/icons/svgmap.svg#reset"></use>
          </svg>
          {{ trans('layout.loadmore') }}
        </button>

      </div>

      <!-- Pagination -->
      <pagination align="center" :data="products_pagged" @pagination-change-page="getPaginationResults" :limit="limit" />
      
      <!-- Example JS tranlation {{ trans('auth.password') }} -->
    </div>
</template>

<script>

import productList from "./../mixins/productList";
import cardMode from "./../mixins/cardMode";
import filter_flow from "./FilterFlow";
import product_item_flow from "./ProductItemFlow";

export default {
    components: {
        filter_flow,
        product_item_flow
    },
    mixins: [
        productList,
        cardMode
    ],
    computed: {
        axioDataMore: function () {
            return {
                category_id: this.category.id,
                page: this.products_pagged.current_page + 1,
                filter: this.filter_query
            }
        }
    },
    methods: {
        axioDataPagination(page) {
            return {
                category_id: this.category.id,
                page: page,
                filter: this.filter_query
            }
        }
    }
}
</script>
